module.exports = __webpack_public_path__ + "static/media/boat-dash.c952ebc8.jpg";